export default __webpack_public_path__ + "static/char-31-88951b92c704bdbd1989f90a7e5acfe7.gif";